import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Layout } from './Routes/Layout';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { ProtectedRouteAdministrador } from './admin/UserContext';
import ScrollToTop from './Routes/ScrollToTop';
import {  HelmetProvider } from "react-helmet-async";

if (typeof window === "undefined") {
  global.console = {
    log: () => {},
    warn: () => {},
    error: (...args) => {
      console.error("🔥 react-snap error:", ...args);
    },
  };
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ScrollToTop/>
    <ProtectedRouteAdministrador>
      <HelmetProvider>
      <Layout/>
      </HelmetProvider>
    </ProtectedRouteAdministrador>
    </BrowserRouter> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
